// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","smallPadding":"styles_smallPadding__3XFB0","mediumPadding":"styles_mediumPadding__M94ot"};